var SecurityUserPreferences = function() {

			var comp = $('[data-page="security-user-preferences"]');

			this.init = function() {
				formValidate();
			}

		// Define os campos a serem validados
		function formValidate() {
			comp.find('#formUserPreferences').validate({
				rules: {
					resultsPerPage: "number",
					email: "required"
				}
			});
		}
		return this.init();
	}
